module.exports = __webpack_public_path__ + "img/page.884a27df.jpg";